declare var Chart;
declare var jQuery;

namespace TotalPoll {

    export class QuestionChartCanvas {
        public $choices;
        public chart;
        public settings: any = {
            data: [],
            type: 'bar',
            options: {
                tooltips: {
                    enabled: false,
                    custom: function (tooltipModel) {
                        // Tooltip Element
                        var tooltipEl = document.getElementById('chartjs-tooltip');

                        // Create element on first render
                        if (!tooltipEl) {
                            tooltipEl = document.createElement('div');
                            tooltipEl.id = 'chartjs-tooltip';
                            tooltipEl.innerHTML = '<table></table>';
                            document.body.appendChild(tooltipEl);
                        }

                        // Hide if no tooltip
                        if (tooltipModel.opacity === 0) {
                            tooltipEl.style.opacity = 0;
                            return;
                        }

                        // Set caret Position
                        tooltipEl.classList.remove('above', 'below', 'no-transform');
                        if (tooltipModel.yAlign) {
                            tooltipEl.classList.add(tooltipModel.yAlign);
                        } else {
                            tooltipEl.classList.add('no-transform');
                        }

                        function getBody(bodyItem) {
                            return bodyItem.lines;
                        }

                        // Set Text
                        if (tooltipModel.body) {
                            var titleLines = tooltipModel.title || [];
                            var bodyLines = tooltipModel.body.map(getBody);

                            var innerHtml = '<thead>';

                            innerHtml += '</thead><tbody>';
                            bodyLines.forEach((body, i) => {
                                var colors = tooltipModel.labelColors[i];
                                var checked = !!this._chart.data.checked[tooltipModel.dataPoints[0].index];
                                innerHtml += `<tr><td><span style="${checked ? 'text-decoration: underline' : ''}">${body}</span></td></tr>`;
                            });
                            innerHtml += '</tbody>';

                            var tableRoot = tooltipEl.querySelector('table');
                            tableRoot.innerHTML = innerHtml;
                        }

                        // `this` will be the overall tooltip
                        var position = this._chart.canvas.getBoundingClientRect();

                        // Display, position, and set styles for font
                        tooltipEl.style.opacity = 1;
                        tooltipEl.style.position = 'absolute';
                        tooltipEl.style.transform = 'translateY(-150%) translateX(-50%)';
                        tooltipEl.style.backgroundColor = '#000000';
                        tooltipEl.style.color = '#ffffff';
                        tooltipEl.style.left = position.left + window.pageXOffset + tooltipModel.caretX + 'px';
                        tooltipEl.style.top = position.top + window.pageYOffset + tooltipModel.caretY + 'px';
                        tooltipEl.style.fontFamily = tooltipModel._bodyFontFamily;
                        tooltipEl.style.fontSize = tooltipModel.bodyFontSize + 'px';
                        tooltipEl.style.fontStyle = tooltipModel._bodyFontStyle;
                        tooltipEl.style.padding = tooltipModel.yPadding + 'px ' + tooltipModel.xPadding + 'px';
                        tooltipEl.style.pointerEvents = 'none';
                        tooltipEl.style.borderRadius = '4px';
                    }
                },
                legend: {
                    display: true,
                    position: "bottom",
                    align: "center",
                    labels: {
                        padding: 30,
                    },
                },
                animation: {
                    duration: '1000',
                    easing: 'easeOut'
                },
            }
        };

        constructor(public $canvas, public poll) {
            this.settings.data = JSON.parse(this.$canvas.attr('totalpoll-chart-data'));
            this.settings.type = this.$canvas.attr('totalpoll-chart-type');
            if (this.settings.type === 'bar') {
                this.settings.options.legend.display = false;
                this.settings.options.scales = {
                    xAxes: [{
                        ticks: {
                            fontColor: '#000000',
                            autoSkip: false,
                            display: true,
                        },
                        gridLines: {
                            display: true,
                            drawBorder: false
                        }
                    }],
                    yAxes: [{
                        gridLines: {
                            display: true,
                            drawBorder: false
                        },
                        ticks: {
                            display: true,
                            autoSkip: false
                        }
                    }]
                }
            }

            this.settings.options.tooltips.callbacks = {
                label: function (tooltipItem, data) {
                    return "\t" + data.labels[tooltipItem.index] + ": " + data.datasets[0].text[tooltipItem.index];
                }
            };
            this.settings.options.animation.duration = this.$canvas.attr('totalpoll-chart-animation-duration');
            this.settings.options.animation.easing = this.$canvas.attr('totalpoll-chart-animation-easing');
            this.$choices = this.$canvas.next('.totalpoll-question-choices').find('.totalpoll-question-choices-item');

            setTimeout(
                () => {
                    this.setupChart();
                    this.setupChoicesTooltips();
                },
                poll.config['effects']['duration']
            );
        }

        setupChart() {
            this.chart = new Chart(this.$canvas.get(0), this.settings);
        }

        setupChoicesTooltips() {
            // Initialize tooltips for legend items
            this.$choices.each((index, el) => {
                var tooltipSettings = {
                    _chart: this.chart.chart,
                    _chartInstance: this.chart,
                    _data: this.chart.data,
                    _options: this.chart.options.tooltips,
                    _active: [this.chart.getDatasetMeta(0).data[index]]
                };
                var tooltip = new Chart.Tooltip(tooltipSettings, this.chart);
                jQuery(el).data('totalpoll-chart-choice-tooltip', tooltip);
                tooltip.initialize();
            });

            // Draw tooltips on legend mouseover
            this.$choices.mouseover(function () {
                var tooltip = jQuery(this).data('totalpoll-chart-choice-tooltip');
                tooltip.update();
                tooltip.pivot();
                tooltip.transition('swing').draw();
            });

            // Remove tooltip on legend mouseout
            this.$choices.mouseout(() => {
                this.chart.draw();
            });
        }
    }

    // Any further actions
    TotalPoll['Hooks'].addAction("totalpoll/init", function (poll) {
        poll.element.find('[totalpoll-chart]').each((index, canvas) => {
            new QuestionChartCanvas(jQuery(canvas), poll);
        });
    });
}
